












import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class DetailHeader extends Vue {
  @Prop()
  protected type: string;
  @Prop()
  protected title: string;
  @Prop()
  protected size: string;

  private typeImage() {
    if (this.type) {
      return require(`../assets/icons/${this.type}.svg`);
    }
  }

  private getSize() {
    return this.size || "medium";
  }
}
